import { createNamespacedHelpers } from 'vuex-composition-helpers';

import IMarkerIcon from '~/components/map/types/marker/IMarkerIcon';
import rainbowImages from '~/consts/rainbowImages';

import buildReusableMarkerSvgUrl from './buildReusableMarkerSvgUrl';

const buildReusableMarkerSvg = (): IMarkerIcon => {
  const { useGetters } = createNamespacedHelpers('obrazkiBase64');
  const { getImage } = useGetters(['getImage']);
  const { url } = rainbowImages.markerBiura;
  const image = getImage.value(url);

  return {
    url: buildReusableMarkerSvgUrl(image && image.base64 ? image.base64 : ''),
  };
};

export default buildReusableMarkerSvg;
